import React from "react";
import ContactPremium from "../sections/ContactPremium";

const ContactPage = () => {
  return (
    <main className="bg-gray-900">
      <ContactPremium />
    </main>
  );
};

export default ContactPage;
